<template>
  <div class="paper-manage">
    <div class="paper-manage-header">
      <div>报纸文章库</div>
      <div class="btn-wrapper">
        <div class="create-btn" @click="shareAllPaper">分享文章库</div>
      </div>
    </div>
    <list-frame class="questionnaire-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
      <template v-slot:listContent>
        <div class="paper-list-content">
          <div class="table-head">
            <div class="search">
              <span>报纸名称&nbsp;</span>
              <el-select v-model="baozhiName"> <el-option v-for="(item, index) in paperList" :key="index" :label="item.name" :value="item.name"></el-option> </el-select>&nbsp;&nbsp;
              <span>报纸刊期</span>&nbsp; <el-date-picker v-model="fromDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp"> </el-date-picker>&nbsp;
              <span>至</span>&nbsp; <el-date-picker v-model="toDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp"> </el-date-picker>&nbsp;&nbsp;
              <span>文章名称</span>&nbsp;
              <el-input v-model.trim="queryName" :maxlength="500"></el-input>
            </div>
            <div class="btns">
              <div class="head-button" @click="search">
                <img src="@imgs/search_mobile.png" alt="" class="input_icon input_sear" />
                <span>查询</span>
              </div>
              <div class="head-button" @click="reset()" :class="{ inactive: !resetAble }">
                <img src="@imgs/reset.png" alt="" class="input_icon input_sear" />
                <span>重置</span>
              </div>
              <div class="head-button" @click="exportResult">
                <img src="@imgs/icon_download_white_small.png" alt="" class="input_icon input_sear" />
                <span>导出</span>
              </div>
              <div class="head-button" @click="createTopic" :class="{ inactive: !createTopicAble }">
                <img src="@imgs/icon_topic_white_small.png" alt="" class="input_icon input_sear" />
                <span>创建专题</span>
              </div>
            </div>
          </div>
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
            <el-table-column prop="title" label="文章名称" min-width="200"> </el-table-column>
            <el-table-column prop="baoZhiName" label="报纸名称" min-width="100"> </el-table-column>
            <el-table-column prop="epaperName" label="数字报名称" min-width="100"> </el-table-column>
            <el-table-column prop="periodical" label="报纸刊期" min-width="100"> </el-table-column>
            <el-table-column prop="edition" label="版次" min-width="50"> </el-table-column>
            <el-table-column label="操作" min-width="150">
              <template slot-scope="scope">
                <div class="option-button" @click="shareItem(scope.row)">分享</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </list-frame>
    <share-dialog ref="shareDialog" :qrObj="qrObj" :title="'分享报纸'" :typeName="typeName" :isInset="isInset"></share-dialog>
    <share-dialog ref="shareAllDialog" :qrObj="qrObj" :showButtons="[true, false]" :typeName="typeName" :title="'分享报纸文章库'" :isInset="isInset" @handleClick="handleClick"></share-dialog>
    <edit-share ref="editShare"></edit-share>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ListFrame from '@components/list/listFrame'
import ShareDialog from '@components/books/components/ShareDialog.vue'
import api from '@api/paperManager'
import EditShare from './components/editShare'
import compareVipRight from '@components/common/compareVipRight.js'
import TipDialog from '@components/common/TipDialog.vue'
import moment from 'moment'
export default {
  name: 'paperArticleLib',
  mixins: [compareVipRight],
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      paperList: [],
      baozhiName: '',
      queryName: '',
      fromDate: '',
      toDate: '',
      isInset: true, //是否显示分享书刊嵌入代码
      typeName: 'paper',
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0,
        title: ''
      },
      searchedParam: {
        baoZhiName: '',
        publishDateStart: '',
        publishDateEnd: '',
        title: ''
      }
    }
  },
  components: { ListFrame, ShareDialog, EditShare, TipDialog },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    userName() {
      return localStorage.getItem('username')
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    createTopicAble() {
      return this.searchedParam.title && this.tableData.length
    },
    resetAble() {
      return this.queryName.length > 0 || this.baozhiName.length > 0 || this.fromDate || this.toDate
    }
  },

  methods: {
    search() {
      this.pageNo = 1
      this.getArticleList()
    },
    exportResult() {
      const a = document.createElement('a')
      a.style.display = 'none'
      let param = this.searchedParam
      a.href = `${window.PROJECT_CONFIG.BASE_URL}/ebook/epaper/exportArticleList?baoZhiName=${param.baoZhiName}&publishDateStart=${
        param.publishDateStart ? new Date(param.publishDateStart).getTime() : ''
      }&publishDateEnd=${param.publishDateEnd ? new Date(param.publishDateEnd).getTime() : ''}&title=${param.title}&userName=${this.userName}`
      console.log(a.href)
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    createTopic() {
      if (!this.createTopicAble) {
        return
      }
      const param = Object.assign(
        {
          topicName: this.searchedParam.title + '专题', //必填：是	专题名称 默认以“文章名称”搜索内容+专题二字为专题名称，例：宣传部专题、领导人专题
          userName: this.userName, //必填：是	创建人帐号
          module: 'epaper'
        },
        this.searchedParam
      )
      api.addTopic(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.message || '创建失败',
            type: 'error'
          })
        }
      })
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    },
    getManagerList() {
      const param = {
        pageNo: 1,
        pageSize: 11,
        userName: this.booksCurrentSubAccount !== '' ? this.booksCurrentSubAccount : this.userName
      }
      api.getPaperManagerList(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.paperList = res.data.data.content
        }
      })
    },
    getArticleList() {
      const param = {
        pageNo: this.currentPageNo,
        pageSize: 10,
        baoZhiName: this.baozhiName,
        publishDateStart: this.fromDate || '',
        publishDateEnd: this.toDate || '',
        userName: this.booksCurrentSubAccount !== '' ? this.booksCurrentSubAccount : this.userName,
        title: this.queryName
      }
      this.searchedParam = param
      api.getPaperArticleList(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          let data = res.data.data
          this.tableData = data.content.map((item) => {
            return {
              ...item,
              periodical: item.publishDate ? moment(item.publishDate).format('YYYY-MM-DD') : ''
            }
          })
          this.totalCount = data.totalElements
        }
      })
    },
    reset() {
      if (this.resetAble) {
        this.queryName = ''
        this.baozhiName = ''
        this.fromDate = ''
        this.toDate = ''
        this.getArticleList()
      }
    },
    //翻页
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getArticleList()
    },
    shareItem(item) {
      this.$refs.shareDialog.dialogVisible = true
      let routeUrl = this.$router.resolve({ path: '/digitalArticle', query: { id: item.id } })
      this.qrObj.value = window.location.origin + routeUrl.href
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.title = item.title
    },
    shareAllPaper() {
      if (!this.compare({ type: 'boole', key: 'articleLib' })) {
        this.$refs.memberDialog.visible = true
        return
      }
      this.$refs.shareAllDialog.dialogVisible = true
      this.qrObj.value = window.location.href.replace('list', 'paperArticleShare?user=' + this.userName)
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
    },
    handleClick(val) {
      this.$refs.shareAllDialog.dialogVisible = false
      this.$refs.editShare.dialogVisible = true
    }
  },
  watch: {
    booksCurrentSubAccount() {
      this.getArticleList()
      this.getManagerList()
    }
  },
  created() {
    this.getArticleList()
    this.getManagerList()
  }
}
</script>
<style lang="scss" scoped>
.paper-manage {
  padding-left: 18px;
  .paper-manage-header {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    .btn-wrapper {
      display: flex;
      padding-right: 20px;
      .create-btn {
        width: 140px;
        height: 30px;
        font-weight: 500;
        color: #ffffff;
        line-height: 30px;
        background-color: #df5813;
        border-radius: 6px;
        text-align: center;
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }
  .paper-list-content {
    .el-input {
      flex: 1;
      width: 200px;
      input {
        height: 100%;
      }
      .el-input__inner {
        font-size: 14px;
        padding: 2px;
      }
    }
    .table-head {
      padding-bottom: 20px;
      .btns {
        margin-top: 20px;
      }
    }
    .head-button {
      margin-right: 10px;
      color: #f0f0f0;
      font-size: 18px;
      line-height: 36px;
      vertical-align: top;
      text-align: center;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      background-color: rgba(223, 88, 19, 1);
      border-radius: 8px;

      .input_icon {
        width: 22px;
        height: 22px;
        margin-left: 12px;
        display: block;
      }
      span {
        display: block;
        margin: 0 17px;
      }
      &.inactive {
        background-color: #999999;
        cursor: not-allowed;
      }
    }
  }
  .option-button {
    display: inline-block;
    cursor: pointer;
    color: #df5813;
    margin-right: 20px;
  }
}
</style>
